module.exports = __webpack_public_path__ + "static/media/edit.58174eba.png";